import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

import {
  INITIAL_LANGUAGE,
  LANG_QUERY_PARAM,
  RTL_LOCALES,
  SUPPORTED_LOCALES,
} from '~/shared/constants/langConstants'
import { getEnvironment } from '~/shared/helpers/getEnvironment'
import { setLanguageAction } from '~/shared/store/common/actions'
import {
  selectIsInContextEnabled,
  selectLanguage,
} from '~/shared/store/common/selects'

export const useLanguage = (): void => {
  const dispatch = useDispatch()
  const { i18n } = useTranslation()
  const isInContextEnabled = useSelector(selectIsInContextEnabled)
  const language = useSelector(selectLanguage)
  const { isStageEnvironment } = getEnvironment()

  const isInContextActive = isStageEnvironment && isInContextEnabled

  useEffect(() => {
    const langQueryParam =
      new URL(window.location.href).searchParams.get(LANG_QUERY_PARAM) || ''
    const isSupportedLang = SUPPORTED_LOCALES.includes(langQueryParam)
    const langValue = isSupportedLang ? langQueryParam : INITIAL_LANGUAGE

    dispatch(setLanguageAction(langValue))
  }, [dispatch, isInContextActive])

  useEffect(() => {
    i18n.changeLanguage(language)
    document.documentElement.lang = language
    document.documentElement.dir = RTL_LOCALES.includes(language)
      ? 'rtl'
      : 'ltr'
  }, [i18n, language])
}
